/**
 * @module app.prospection.store.gpsCtrl
 */
function GpsCtrl($scope) {
    var self = this;

    var infos = $scope.storeCtrl.store.contact.location || [];
    self.location = infos.coordinates || infos;

    return self;
}
GpsCtrl.$inject = ['$scope'];

angular.module('app.prospection.store.gpsCtrl', []).controller('GpsCtrl', GpsCtrl);
